import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, ToggleLeft, ToggleRight, AlertTriangle } from "lucide-react";
import api, { getErrorMessage } from "@/lib/api";

const SWITCHES = [
  ["show_item_amounts", "Show per-item amounts to subscribers"],
  ["show_item_rates", "Show per-item rates to subscribers"],
  ["show_cost_per_student", "Show cost per student (class and average)"],
  ["show_laddoo_subtotal", "Show laddoo subtotal"],
];

// Admin → Settings → Rate privacy. All OFF by default; visitors/free users never see rates.
export default function RatePrivacyCard() {
  const [rp, setRp] = useState(null);
  const [alerts, setAlerts] = useState([]);
  useEffect(() => {
    api.get("/admin/settings").then(({ data }) => setRp(data.settings?.rate_privacy || {})).catch(() => setRp({}));
    api.get("/admin/security-alerts").then(({ data }) => setAlerts(data.alerts || [])).catch(() => {});
  }, []);
  if (!rp) return null;
  const toggle = async (k) => {
    const next = { ...rp, [k]: !rp[k] };
    setRp(next);
    try { await api.put("/admin/settings", { rate_privacy: next }); toast.success("Rate privacy updated"); }
    catch (e) { setRp(rp); toast.error(getErrorMessage(e)); }
  };
  return (
    <div className="card-thali space-y-3" data-testid="rate-privacy-card">
      <h2 className="font-heading font-bold text-lg flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-thali-green" /> Rate privacy</h2>
      <p className="text-xs text-thali-ink/60">Rates never leave the server. These switches unlock details for <b>active subscribers only</b> (screens and exports, immediately). Visitors and free users never see them. Admin always sees everything.</p>
      {SWITCHES.map(([k, label]) => (
        <button key={k} onClick={() => toggle(k)} className="w-full flex items-center justify-between gap-3 rounded-xl bg-white border border-thali-turmeric/30 p-3 text-left" data-testid={`rp-${k}`}>
          <span className="text-sm font-semibold">{label}</span>
          <span className={`flex items-center gap-1 font-bold text-sm ${rp[k] ? "text-thali-green" : "text-thali-ink/50"}`}>
            {rp[k] ? <ToggleRight className="w-8 h-8" /> : <ToggleLeft className="w-8 h-8" />}{rp[k] ? "ON" : "OFF"}
          </span>
        </button>
      ))}
      <div className="pt-2" data-testid="security-alerts">
        <div className="text-sm font-bold flex items-center gap-1"><AlertTriangle className="w-4 h-4 text-amber-600" /> Suspicious calculation activity ({alerts.length})</div>
        {alerts.length === 0 && <div className="text-xs text-thali-ink/50">No alerts.</div>}
        {alerts.slice(0, 10).map((a, i) => (
          <div key={i} className="text-xs rounded-lg bg-amber-50 p-2 mt-1">{a.name || "—"} · {a.mobile || ""} · {a.detail} · {String(a.created_at).slice(0, 16).replace("T", " ")}</div>
        ))}
      </div>
    </div>
  );
}
